// In your main.scss or index.scss
// import "./bootstrap/scss/bootstrap";
import "./scss/main.scss";
import { chatBot, getFullYear } from "./js/site";

document.addEventListener("DOMContentLoaded", () => {
  chatBot();
  getFullYear();
});
